import React from 'react';
import { HeadCard } from '../../structure/card/HeadCard';
import { DatatableClientes } from './DatatableClientes';

export const ClientesPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="Clientes" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>
                    <DatatableClientes />
                </div>
            </section>
        </div>
    );
};
